<template>

  <v-app dark>



    <v-main class="app-container disable-select" app>      

    <Toolbar v-if="$route.meta.hasToolbar" />

      <router-view v-slot="{ Component }">

        <transition :name="$route.meta.transition" mode="out-in" v-if="$route.meta.transition" appear>

          <keep-alive :max="6" v-if="$route.meta.keepAlive">

            <component :is="Component" />

          </keep-alive>

          <component v-else :is="Component" />

        </transition>

        <component v-else :is="Component" />

      </router-view>


    </v-main>

    <Footer v-if="$route.meta.hasFooter" />    

  </v-app>
</template>


<script>


import Footer  from './components/Footer.vue'

import Toolbar  from './components/Toolbar.vue'

export default {
  name: 'App',

  components: {    
    Footer,
    Toolbar
  },
  data: () => ({
    title: 'title',
    message:'',
    items:[],
    
    //bgStyle: 'background:linear-gradient(to bottom, #414345, #232526)',
  }),
  mounted(){

/*
    navigator.mediaDevices.getUserMedia({ video: true, audio:true })
    .then(function(stream) {
      // Do something with the stream, such as displaying it in a video element
      alert('vid');
    })
    .catch(function(error) {
      // Handle the error
      alert('no vid');
    });
*/

  },
}
</script>


<style lang="scss">

  .primary{
     background: #0078c9 !important;/*linear-gradient(281deg,#420be6,#a16bb3) !important;*/
     /* linear-gradient(to right, #1fa2ff, #12d8fa, #a6ffcb) !important; */
      /*background: linear-gradient(135deg, #006fba 0%,#2989d8 50%,#00558e 100%) !important;*/
  }

  @font-face {
    font-family: 'DinPro-Regular'; 
    src: url('./assets/fonts/dinpro_regular.woff2') format('woff2');
  }
  @font-face {
    font-family: 'DinPro-Medium'; 
    src: url('./assets/fonts/dinpro_medium.woff2') format('woff2');
  }
  @font-face {
    font-family: 'DinPro-Light'; 
    src: url('./assets/fonts/dinpro_light.woff2') format('woff2');
  }
  @font-face {
    font-family: 'DinPro-Bold'; 
    src: url('./assets/fonts/dinpro_bold.woff2') format('woff2');
  }
  @font-face {
    font-family: 'DinPro-Black'; 
    src: url('./assets/fonts/dinpro_black.woff2') format('woff2');
  }
    @font-face {
    font-family: 'DinPro-Cond-Medium'; 
    src: url('./assets/fonts/dinpro_cond_medium.woff2') format('woff2');
  }
  .dinpro-regular{
    font-family: 'DinPro-Regular', sans-serif; 
  }
  .dinpro-medium{
    font-family: 'DinPro-Medium', sans-serif; 
  }
  .dinpro-light{
    font-family: 'DinPro-Light', sans-serif; 
  }
  .dinpro-bold{
    font-family: 'DinPro-Bold', sans-serif; 
  }
  .dinpro-black{
    font-family: 'DinPro-Black', sans-serif; 
  }  
  .dinpro-cond-medium{
    font-family: 'DinPro-Cond-Medium', sans-serif; 
  }
  $app-color: #0078CA;
  $app-shadow: #00548D;
  $app-bg: #ffffff;/*#222126;*/
  $app-container: #313035;/*rgb(245, 245, 245); #313035;*/


  body{
    background: $app-container;
  }

  .app-container{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
      height: 100%;
      background:$app-bg;
        /*background:url(./assets/images/content_body.jpg);*/

  }

  .disable-select {
      user-select: none; /* supported by Chrome and Opera */
     -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
     -moz-user-select: none; /* Firefox */
     -ms-user-select: none; /* Internet Explorer/Edge */
  }

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}


  @keyframes bubble-anim {
  0% {

    transform: scale(1); }

  20% {

    transform: scaleY(0.95) scaleX(1.02); }

  48% {

    transform: scaleY(1.1) scaleX(0.9); }

  68% {

    transform: scaleY(0.98) scaleX(1.02); }

  80% {

    transform: scaleY(1.02) scaleX(0.98); }

  97%, 100% {

    transform: scale(1); } 
  }


  .jiggle{
    animation: bubble-anim 1s ease-in;
    backface-visibility: hidden;
  }
  @keyframes shake{
      10%, 90% {transform: translate3d(-1px, 0, 0);
         }    
      20%, 80% {transform: translate3d(2px, 0, 0); }
      30%, 50%, 70% {transform: translate3d(-4px, 0, 0);  }
      40%, 60% {transform: translate3d(4px, 0, 0); }
}

.shake {

  animation: shake 1.3s cubic-bezier(.36,.07,.19,.97) both;
  transform: translateZ(0);
  backface-visibility: hidden;

} 

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

.bouncein{
  animation: bounce-in .5s ease;
  backface-visibility: hidden;
}

.v-badge__badge{
  height:26px;
  width:26px;
}
</style>

